const popupProductForm = document.querySelector('#popup-product-form');
const popupOpener = document.querySelector('.popup-form__block-initial .popup-opener');

let updateActiveCanImage = (canImages, quantity) => {
    canImages.forEach((image, index) => {
        if (index < quantity) {
            image.style.display = 'block';
            image.classList.add('available');
        } else {
            image.style.display = 'none';
            image.classList.remove('available');
        }
    });
}

let updateVariantPrice = (priceElement, price, comparePrice) => {
    priceElement.querySelector('.form-product__price .sale-price').textContent = price;
    priceElement.querySelector('.form-product__price .original-price').textContent = comparePrice;
};

let updateServingsCount = (formElement, servingsCount) => {
    if (servingsCount !== "0") {
        let price = Array.from(formElement.querySelectorAll('input[name="varian-quantity"]')).find((element) => element.checked).getAttribute('data-price');
        let comparePrice = Array.from(formElement.querySelectorAll('input[name="varian-quantity"]')).find((element) => element.checked).getAttribute('data-compare-price');
        formElement.querySelector('.servings__text').querySelector('.servings__subscription').textContent = `$ ${((Number(price) / Number(servingsCount)) / 100).toFixed(2)} per serving`;
        formElement.querySelector('.servings__text').querySelector('.servings__one-time').textContent = `$ ${((Number(comparePrice) / Number(servingsCount)) / 100).toFixed(2)} per serving`;
    } else {
        formElement.querySelector('.servings__text').querySelector('.servings__subscription').textContent = '';
        formElement.querySelector('.servings__text').querySelector('.servings__one-time').textContent = '';
    }
};

let updateDynamicInformation = () => {
    let actualVariant = Array.from(popupProductForm.querySelectorAll('input[name="varian-quantity"]')).find((element) => element.checked)
    let allFlavors = Array.from(popupProductForm.querySelectorAll('[data-quantity]'));
    let maxQuantity = Number(popupProductForm.querySelector('[data-max-selected]').getAttribute('data-max-selected'));
    let dataFlavorTextDefault = popupProductForm.querySelector('.information-data__flavor').getAttribute('data-default');
    let dataFlavorTextFinal = popupProductForm.querySelector('.information-data__flavor').getAttribute('data-final');

    if(!dataFlavorTextDefault){
        dataFlavorTextDefault = 'Select | more';
    }

    if(!dataFlavorTextFinal){
        dataFlavorTextFinal = 'Good choice!';
    }

    let actualQuantity = allFlavors.reduce((sum, element) => {
        return sum + (parseInt(element.value, 10) || 0);
    }, 0);

    popupProductForm.querySelector('.information-data__quantity').textContent = actualVariant.parentNode.querySelector('.sub-name-quantity')?.textContent;
    // console.log(maxQuantity, actualQuantity, 'maxQuantity, actualQuantity');
    if (maxQuantity > actualQuantity) {
        popupProductForm.querySelector('.information-data__flavor').textContent = `${dataFlavorTextDefault.replace('|', (maxQuantity - actualQuantity))}`;
        popupProductForm.querySelector('.form-product__buttons .form-checkout--button').setAttribute('data-available', 'false');
    } else if (maxQuantity === actualQuantity) {
        popupProductForm.querySelector('.information-data__flavor').textContent = `${dataFlavorTextFinal}`;
        popupProductForm.querySelector('.form-product__buttons .form-checkout--button').setAttribute('data-available', 'true');
    }
};

if (popupProductForm && popupOpener) {
    let canImages = popupProductForm.querySelectorAll('.popup-product-form__image');
    let variantQuantityElements = popupProductForm.querySelectorAll('input[name="varian-quantity"]');
    let initialQuantity = Array.from(variantQuantityElements).find((element) => element.checked).value;
    let formNextStep = popupProductForm.querySelector('.form-product__buttons .next-step--button');
    let formCheckout = popupProductForm.querySelector('.form-product__buttons .form-checkout--button');
    let initialPrice = Array.from(variantQuantityElements).find((element) => element.checked).parentNode.querySelector('.name-price').textContent;
    let initialComparePrice = Array.from(variantQuantityElements).find((element) => element.checked).parentNode.querySelector('.name-compare-price').textContent;
    let initialServingsCount = Array.from(variantQuantityElements).find((element) => element.checked).getAttribute('data-servings');
    let planSwitcher = popupProductForm.querySelector('.switcher--plan');

    planSwitcher.addEventListener('click', (event) => {
        if (planSwitcher.classList.contains('one-time-plan')) {
            popupProductForm.classList.remove('one-time--plan-state');
            document.querySelector('.standard__app .subscription-radio input').cheked = true;
            document.querySelector('.standard__app .subscription-radio input').dispatchEvent(new Event('change'));
        } else {
            popupProductForm.classList.add('one-time--plan-state');
            document.querySelector('.standard__app .onetime-radio input').cheked = true;
            document.querySelector('.standard__app .onetime-radio input').dispatchEvent(new Event('change'));
        }
        planSwitcher.classList.toggle('one-time-plan');
    });

    formCheckout.addEventListener('click', () => {
        let allFlavors = Array.from(popupProductForm.querySelectorAll('[data-quantity]'));
        let maxQuantity = Number(popupProductForm.querySelector('[data-max-selected]').getAttribute('data-max-selected'));

        let actualQuantity = allFlavors.reduce((sum, element) => {
            return sum + (parseInt(element.value, 10) || 0);
        }, 0);

        if (maxQuantity > actualQuantity) {
            popupProductForm.querySelector('.notification__error-picker').classList.add('notification__error-picker--active');
            setTimeout(() => {
                popupProductForm.querySelector('.notification__error-picker').classList.remove('notification__error-picker--active');
            }, 1500);
        } else if (maxQuantity === actualQuantity) {
            popupProductForm.classList.remove('open', 'quantity--step');
        }
    });

    popupOpener.addEventListener('click', () => {
        updateActiveCanImage(canImages, initialQuantity);
        popupProductForm.classList.add('open', 'quantity--step');
        updateVariantPrice(popupProductForm, initialPrice, initialComparePrice);
        updateServingsCount(popupProductForm, initialServingsCount);
        setTimeout(() => {
            updateDynamicInformation()
        }, 10);
    });

    window.addEventListener('update::value', (event) => {
        let { name, type, image } = event.detail;
        let availableImages = Array.from(canImages).filter((img) => img.classList.contains('available'));

        if (type === 'add') {
            let targetElement = availableImages.find((img) => !img.querySelector('.variant-image').dataset.name);

            if (targetElement) {
                let variantElement = targetElement.querySelector('.variant-image');
                variantElement.src = image;
                variantElement.dataset.name = name;
                targetElement.classList.add('active');
            }
        } else if (type === 'remove') {
            let targetElement = [...availableImages].reverse().find((img) => img.querySelector('.variant-image').dataset.name === name);

            if (targetElement) {
                let variantElement = targetElement.querySelector('.variant-image');
                variantElement.src = '';
                variantElement.dataset.name = '';
                targetElement.classList.remove('active');
            }
        }

        let filledImages = availableImages.filter((img) => img.querySelector('.variant-image').dataset.name);
        let emptyImages = availableImages.filter((img) => !img.querySelector('.variant-image').dataset.name);

        filledImages.forEach((img, index) => {
            let targetVariant = availableImages[index].querySelector('.variant-image');
            let sourceVariant = img.querySelector('.variant-image');
            targetVariant.src = sourceVariant.src;
            targetVariant.dataset.name = sourceVariant.dataset.name;

            availableImages[index].classList.add('active');
        });

        emptyImages.forEach((img, index) => {
            let targetVariant = availableImages[filledImages.length + index].querySelector('.variant-image');
            targetVariant.src = '';
            targetVariant.dataset.name = '';

            availableImages[filledImages.length + index].classList.remove('active');
        });

        setTimeout(() => {
            updateDynamicInformation()
        }, 10);
    });


    window.addEventListener('reset::data', (event) => {
        let availableImages = Array.from(canImages)
        availableImages.forEach((img) => {
            let variantElement = img.querySelector('.variant-image');
            variantElement.src = '';
            variantElement.dataset.name = '';
            img.classList.remove('active');
        });

        setTimeout(() => {
            updateDynamicInformation()
        }, 10);
    });



    variantQuantityElements.forEach((element) => {
        element.addEventListener('change', () => {
            let quantity = element.value;
            let updatePrice = Array.from(variantQuantityElements).find((element) => element.checked).parentNode.querySelector('.name-price').textContent;
            let updatedComparePrice = Array.from(variantQuantityElements).find((element) => element.checked).parentNode.querySelector('.name-compare-price').textContent;
            let servingsCount = Array.from(variantQuantityElements).find((element) => element.checked).getAttribute('data-servings');

            initialQuantity = quantity;
            updateActiveCanImage(canImages, quantity);
            updateVariantPrice(popupProductForm, updatePrice, updatedComparePrice);
            updateServingsCount(popupProductForm, servingsCount);

            setTimeout(() => {
                updateDynamicInformation()
            }, 10);
        });
    });

    popupProductForm.addEventListener('click', (event) => {
        if (event.target.classList.contains('close--popup')) {
            popupProductForm.classList.remove('open', 'quantity--step');
        }
        if (event.target === formNextStep) {
            popupProductForm.classList.add('flavor--step');
        }
        if (event.target.classList.contains('previous--step')) {
            popupProductForm.classList.remove('flavor--step');
        }
    });
}

